<fieldset>
  <legend class="group-label fw-bold">Voorkeur belafspraak</legend>
  <rfa-errors [control]="dayControl"></rfa-errors>
  <rfa-errors [control]="timeControl"></rfa-errors>
  <div class="group-container">
    <div class="group-input group-input-medium">
      <crnt-form-control-label slot="label">
        <label
          class="fw-normal"
          [wlAutomationId]="dayControl.options.dataAutomationId"
          [for]="dayControl.id"
        >
          {{ dayControl.options.label }}
        </label>
      </crnt-form-control-label>
      @if (dayControl.options.helpText) {
        <crnt-form-control-help-text slot="help">
          {{ dayControl.options.helpText }}
        </crnt-form-control-help-text>
      }

      <crnt-select [state]="dayControl.hasError() ? 'invalid' : 'enabled'">
        <select
          [id]="dayControl.id"
          [formControl]="dayControl"
          [wlTrackValueChange]="valueChangeTrackConfig(dayControl)"
          [wlAutomationId]="dayControl.options.dataAutomationId"
          [attr.aria-describedby]="ariaDescribedBy(dayControl)"
        >
          <option selected ngValue=""></option>
          @for (item of daysOptions().entries; track $index) {
            <option [ngValue]="item.value">{{ item.text | date }}</option>
          }
        </select>
      </crnt-select>
    </div>
    @if (timesOptions().entries.length > 0) {
      <div class="group-input group-input-medium">
        <crnt-form-control-label slot="label">
          <label
            class="fw-normal"
            [wlAutomationId]="timeControl.options.dataAutomationId"
            [for]="timeControl.id"
          >
            {{ timeControl.options.label }}
          </label>
        </crnt-form-control-label>
        @if (timeControl.options.helpText) {
          <crnt-form-control-help-text slot="help">
            {{ timeControl.options.helpText }}
          </crnt-form-control-help-text>
        }

        <crnt-select [state]="timeControl.hasError() ? 'invalid' : 'enabled'">
          <select
            [id]="timeControl.id"
            [formControl]="timeControl"
            [wlTrackValueChange]="valueChangeTrackConfig(timeControl)"
            [wlAutomationId]="timeControl.options.dataAutomationId"
            [attr.aria-describedby]="ariaDescribedBy(timeControl)"
          >
            <option selected ngValue=""></option>
            @for (item of timesOptions().entries; track $index) {
              <option [ngValue]="item.value">{{ item.text }}</option>
            }
          </select>
        </crnt-select>
      </div>
    }
  </div>
</fieldset>
